import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { actions as processActions } from "modules/process"
import { actions as userActions } from "modules/user"
import { actions as accountActions } from "modules/account"
import { actions as dataActions } from "modules/data"

import View from "./"

const mapDispatchToProps = dispatch => {
  const actions = {
    login: accountActions.login,
    logout: accountActions.logout,
    getUser: userActions.getUser,
    clearUser: userActions.clearUser,
    setOrganization: dataActions.setOrganization,
    processFailure: processActions.processFailure,
  }

  return bindActionCreators(actions, dispatch)
}

const mapStateToProps = ({ account, process, data, user, candidate }) => ({
  account,
  process,
  user,
  loading: process.type === "login" && process.status === "loading",
  organization: data.organization,
  candidate,
  translationMap: data.translationMap,
})

export default connect(mapStateToProps, mapDispatchToProps)(View)
